import React, { createContext, useContext, useState } from 'react';

const QuoteContext = createContext(null);

export const useQuote = () => {
    const context = useContext(QuoteContext);
    if (!context) {
        throw new Error('useQuote must be used within a QuoteProvider');
    }
    return context;
};

export const QuoteProvider = ({ children }) => {
    const [customerDetails, setCustomerDetails] = useState({
        company_name: '',
        contact_name: '',
        contact_job_title: '',
        email: '',
        phone: '',
        address: ''
    });
    
    // Multi-pack: array of { pack, quantity }
    const [selectedItems, setSelectedItems] = useState([]);
    const [createdQuote, setCreatedQuote] = useState(null);

    // Legacy compat
    const selectedPack = selectedItems.length > 0 ? selectedItems[0].pack : null;
    const setSelectedPack = (pack) => {
        if (pack) setSelectedItems([{ pack, quantity: 1 }]);
        else setSelectedItems([]);
    };

    const addItem = (pack) => {
        setSelectedItems(prev => {
            const existing = prev.find(i => i.pack.id === pack.id);
            if (existing) return prev; // Already added
            return [...prev, { pack, quantity: 1 }];
        });
    };

    const removeItem = (packId) => {
        setSelectedItems(prev => prev.filter(i => i.pack.id !== packId));
    };

    const updateQuantity = (packId, quantity) => {
        const qty = Math.max(1, Math.min(99, quantity));
        setSelectedItems(prev =>
            prev.map(i => i.pack.id === packId ? { ...i, quantity: qty } : i)
        );
    };

    const resetQuote = () => {
        setCustomerDetails({ company_name: '', contact_name: '', contact_job_title: '', email: '', phone: '', address: '' });
        setSelectedItems([]);
        setCreatedQuote(null);
    };

    const value = {
        customerDetails,
        setCustomerDetails,
        selectedItems,
        setSelectedItems,
        addItem,
        removeItem,
        updateQuantity,
        selectedPack,
        setSelectedPack,
        createdQuote,
        setCreatedQuote,
        resetQuote
    };

    return (
        <QuoteContext.Provider value={value}>
            {children}
        </QuoteContext.Provider>
    );
};

export default QuoteContext;
